import React from "react";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
export default withRouter(props => {
  return (
    <div className="not-found">
      Oops! We couldn't resolve the page{" "}
      <em>
        <mark>"{`${props.location.pathname}`}"</mark>{" "}
      </em>
      you're looking for.
      <div>
        Please, start again from
        <Link to="/"> here</Link>
      </div>
    </div>
  );
});
